import React, { useMemo } from 'react';
import { List } from 'immutable';
import { Tag } from '../../../../../../../common/tags/tagTypes';
import TagsListElement from './TagsListElement';
import { getTags } from '../../../../../../../common/elements/utils/elementPropertyUtils';
import { ImMNElement } from '../../../../../../../common/elements/elementModelTypes';
import { generateTagsByBoardsArray } from '../tagUtils';

type Props = {
    handleToggleTagSelection: (tag: Tag) => void;
    handleClickEdit: (tag: Tag) => void;
    handleCreateCopyAndAddToElement: (tag: Tag) => void;
    elements: List<ImMNElement>;
    searchString: string;
    userRootPath: ImMNElement[];
    allTags: Tag[];
    retreivingElementsForTag: string | null;
};

const TagLists = (props: Props) => {
    const {
        handleToggleTagSelection,
        handleClickEdit,
        elements,
        searchString,
        userRootPath,
        allTags,
        retreivingElementsForTag,
    } = props;

    const elementTagIds = elements.flatMap((element) => getTags(element) || []);
    const tagsByBoards = useMemo(
        () => generateTagsByBoardsArray(allTags, userRootPath, searchString),
        [allTags, userRootPath, searchString],
    );

    return (
        <div className="TagLists">
            {tagsByBoards.map(({ title, tags }, index) => {
                return (
                    <div key={index} className="mb-3">
                        {title && <p className="w-full text-left mb-1">{title}</p>}
                        {tags.map((tag) => {
                            return (
                                <TagsListElement
                                    key={tag.id}
                                    tag={tag}
                                    isSelected={elementTagIds?.includes(tag.id)}
                                    handleClickTag={handleToggleTagSelection}
                                    handleClickEdit={handleClickEdit}
                                    retreivingElementsForTag={retreivingElementsForTag}
                                />
                            );
                        })}
                    </div>
                );
            })}
        </div>
    );
};

export default TagLists;
